import { getQueryFromParams } from "./utils/query-params";

const settings = {};

settings.isDevelopment = process.env.NODE_ENV !== "production";

settings.baseUrl = process.env.PUBLIC_URL || "";

settings.stats = false; //getQueryFromParams("stats") === null;

settings.devCamera = getQueryFromParams("devCamera") === "true";

settings.helpers = getQueryFromParams("helpers") === "true";

settings.datGui = false; //getQueryFromParams("gui") === null;

settings.viewportPreviewScale = 0.25;

settings.renderBufferFullscreen = false;

settings.pixelRatio = Math.min(window.devicePixelRatio, 2);

export default settings;
